import React from 'react';

import styles from './quote-estimates.module.scss';

const loaderSrc = 'https://policygenius-images.imgix.net/icons/loading-animation.gif';

const Loader = () => (
  <div className={styles['loader-container']} data-testid="quote-estimates-loader">
    <img src={loaderSrc} alt="Loader gif" className={styles.img} />
  </div>
);

export default Loader;
